import { takeLatest, put, call, select } from 'redux-saga/effects';
import { EXPORT_SALES_TO_EXCEL_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import { setLocalStorage } from "../../helpers/LocalStorage";
import growl from "../../lib/growl/growl";
import * as XLSX from "xlsx";

const request = data => {
    return fetch(`${ url }/export_sales_to_excel`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerExportSalesToExcel(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);
        formData.append('date_from', args?.data?.from || '');
        formData.append('date_to', args?.data?.to || '');
        formData.append('subscription_type', args?.data?.subscription_type || '');
        formData.append('subscription_coach', args?.data?.subscription_coach || '');
        formData.append('sales_type', args?.data?.sales_type || '');
        formData.append('payment_methods', args?.data?.payment_methods);
        formData.append('min_sum', args?.data?.minSum || '');
        formData.append('max_sum', args?.data?.maxSum || '');
        formData.append('sales_user', args?.data?.sales_user || '');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response?.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }
        else if (response?.error) {
            growl({ type: 'error', message: response.message });
        }
        else if (response?.success) {
            // Проверяем наличие элементов в массиве
            if (response.sales.length) {
                let result = [Object.keys(response.sales[0])];
                response.sales.forEach(elem => {
                    result.push(Object.values(elem));
                });

                const dates_interval = `${ new Date(args?.data?.from).toLocaleDateString('ru-Ru') } − ${ new Date(args?.data?.to).toLocaleDateString('ru-Ru') }`;
                const ws = XLSX.utils.aoa_to_sheet(result);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, dates_interval);
                XLSX.writeFile(wb, `${ dates_interval }.xlsx`);
            }
            else {
                growl({ type: 'warning', message: 'Нет записей. Укажите другие параметры поиска.' });
            }
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherExportSalesToExcel() {
    yield takeLatest(EXPORT_SALES_TO_EXCEL_SAGA, workerExportSalesToExcel);
}